<template>
    <div class="default-message">
<!--        <div v-if="appData.selectedMenu == 'talk'">-->
        <div>
            <span v-html="$t('message.hint_menu_talkHistory1')"></span>
            <br>
            <hr class="hint-hr">
            <br>
            <table class="hint-table" align="center">
                <tr>
                    <td class="hint-table-title" v-t="'message.hint_menu_talkHistory2'"></td>
                </tr>
                <tr>
                    <td class="hint-table-item" v-t="'message.hint_menu_talkHistory3'"></td>
                </tr>
                <tr>
                    <td class="hint-table-title" v-t="'message.hint_menu_talkHistory4'"></td>
                </tr>
                <tr>
                    <td class="hint-table-item" v-t="'message.hint_menu_talkHistory5'"></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {};
    },
    methods: {},
    components: {},
    props: ['appData']
}

</script>
